import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAlertPopupModel } from '../../models/popup.model';
import { BasePopupComponent } from '../base-popup/base-popup.component';
@Component({
    selector: 'app-confirmation-popup',
    standalone: false,
    templateUrl: './confirmation-popup.component.html',
    styleUrl: './confirmation-popup.component.scss',
})
export class ConfirmationPopupComponent extends BasePopupComponent {
    protected cancelButtonLabel: string = 'Cancel';
    protected confirmButtonLabel: string = 'Okay';
    protected iconPath: string = '';
    protected message: string = 'Are you sure you want to proceed?';
    protected title: string = 'Please Confirm';

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: IAlertPopupModel,
        protected override dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    ) {
        super(data, dialogRef);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.data) {
            this.title = this.data.title || this.title;
            this.message = this.data.message || this.message;
            this.iconPath = this.data.iconPath || this.iconPath;
            this.confirmButtonLabel = this.data.confirmButtonLabel || this.confirmButtonLabel;
            this.cancelButtonLabel = this.data.cancelButtonLabel || this.cancelButtonLabel;
        }
    }
}
